"use strict";const t=require("styled-components").css`
    &.DXContactCard {
        position: relative;
    }
    .DXTypography {
        margin: 0px;
    }
    .DXContactCard-heading {
        padding-bottom: 10px;
        margin-bottom: 20px;
        border-bottom: solid 1px ${({theme:t})=>t.colors.grey[400]};
    }

    .DXContactCard-content {
        position: relative;
        padding-right: 30px;
        display: block;
    }
    .DXContactCard-item-list {
        position: relative;
        margin-top: 7px;
        .DXTypography {
            color: ${({theme:t})=>t.colors.grey[700]};
            display: flex;
            align-items: center;
            span {
                display: flex;
                align-items: center;
            }
        }
        .DXContactCard-icon {
            margin-right: 12px;
            width: 16px;
            svg {
                max-width: 100%;
            }
        }
    }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
